import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createBenefits, getAllBenefits } from "../../../apis/benefits";
import { BenefitsSchema } from "../../../lib/validations/benefitsValidations";
import TextInputFormik from "../../../lib/common/TextInputFormik";

export default function AddBenefits() {
  const [loading, setLoading] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [benefits, setBenefits] = useState([]);
  const [addLocationsInitial, setAddLocationsInitial] = useState({
    name: "",
    image: "",
    discription: "",
    startDate: "",
    endDate: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      editBenefit(id);
    }
    // getbenefits()
  }, [id]);

  const editBenefit = async (id) => {
    // setEditLoader(true)
    try {
      const res = await getAllBenefits(id);
      console.log("result", res);
      if (res.result) {
        const startDate = new Date(res.result?.startDate)
          .toISOString()
          .split("T")[0];
        const endDate = new Date(res.result?.endDate)
          .toISOString()
          .split("T")[0];
        setAddLocationsInitial({
          name: res.result.name,
          image: res.result.image,
          discription: res.result.discription,
          startDate: startDate,
          endDate: endDate,
        });
      }
    } catch (error) {
      console.error("Error fetching Locations:", error);
    } finally {
      setLoading(false);
    }
  };
  const getbenefits = async () => {
    try {
      const res = await getAllBenefits();
      if (res?.result) {
        setBenefits(res.result);
      }
    } catch (err) {
      console.error("Failed to fetch categories:", err);
    }
  };
  const formik = useFormik({
    initialValues: addLocationsInitial,
    enableReinitialize: true,
    validationSchema: BenefitsSchema,
    onSubmit: async (values) => {
      console.log(values);
      try {
        setLoading(true);
        // console.log(values)
        let res;
        if (id) {
          res = await createBenefits(id, values);
          console.log(res);
        } else {
          res = await createBenefits(null, values);
        }
        setLoading(false);
        formik.resetForm();
        navigate("/benefits");
      } catch (error) {
        console.error("Error submitting form:", error);
        throw error;
      }
    },
  });
  const backClick = () => {
    navigate("/benefits");
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            {" "}
            <i
              className="fas fa-arrow-left"
              style={{ marginRight: "30px", fontSize: "20px" }}
              onClick={backClick}
            />
            <div className="my-3 p-3 bg-body rounded shadow-sm">
              {editLoader ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "50px", padding: "7px 30px" }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                  {/* Name */}
                  <TextInputFormik label="Name" field="name" formik={formik} />

                  {/* Address */}
                  <TextInputFormik
                    // type="image"
                    label="Image"
                    field="image"
                    formik={formik}
                  />

                  {/* Description */}
                  <TextInputFormik
                    label="Description"
                    field="discription"
                    formik={formik}
                  />

                  {/* StartDate */}
                  <TextInputFormik
                    type="date"
                    label="StartDate"
                    field="startDate"
                    formik={formik}
                  />

                  {/* EndDate */}
                  <TextInputFormik
                    type="date"
                    label="EndDate"
                    field="endDate"
                    formik={formik}
                  />

                  {/* Submit button or loading spinner */}
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "50px", padding: "7px 30px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button className="btn btn-primary" type="submit">
                      {id ? "Update" : "Submit"}
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
